<template>
  <!-- rf03 -->
  <v-content class="pa-12">
    <v-layout style="background-color: #FAF5F2;">
      <v-flex>
        <v-flex shrink style="text-align: right"><v-btn dark @click="printPage()"
            style="width: 80px; background-color: black;"><v-icon>local_printshop</v-icon></v-btn></v-flex>
        <v-layout mb-4>
          <v-flex style="font-size: 28px;font-weight: bold;color: #737373">
            <span>แบบฟอร์ม</span>
          </v-flex>
        </v-layout>

        <div id="print" style="height: auto">
          <div class="print-form">
            <v-layout mx-6>
              <v-flex>
                <v-layout style="background-color: #3E7662;">
                  <v-flex my-4 ml-8 style="text-align: left;font-size: 28px;color: white">
                    <div style="font-weight: bold">
                      แบบประเมินรายงานความก้าวหน้าของการวิจัย
                    </div>
                    <div style="font-size: 18px;">
                      Assessment Form of Progress Report
                    </div>
                  </v-flex>
                  <v-flex ml-8 pt-8 pr-8 style="text-align: right;font-weight: bold;font-size: 13px;color: white">
                    <span>RO 06_2563</span>
                  </v-flex>
                </v-layout>

                <!-- Start Form -->

                <!-- Card 1 -->
                <v-card class="mb-12">
                  <v-layout pa-12 class="justify-center">
                    <v-flex xs10>
                      <!-- row 1 -->
                      <v-layout mb-8>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>รหัสโครงร่างการวิจัย</b>
                        </v-flex>
                        <v-flex xs4 class="text-start">
                          <TextfieldForm readonly :model="form.researchCode" hide-detail
                            @update-data="updateData('researchCode', $event)" />
                        </v-flex>
                        <v-spacer></v-spacer>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout mb-8>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>ชื่อผู้วิจัยหลัก</b>
                        </v-flex>
                        <v-flex xs4 class="text-start">
                          <TextfieldForm readonly :model="form.firstName" hide-detail
                            @update-data="updateData('firstName', $event)" />
                        </v-flex>
                        <v-flex mx-4 xs1 class="d-flex justify-end align-center">
                          <b>นามสกุล</b>
                        </v-flex>
                        <v-flex>
                          <TextfieldForm readonly :model="form.lastName" hide-detail
                            @update-data="updateData('lastName', $event)" />
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout mb-8>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>ชื่อโครงการวิจัย (ไทย)</b>
                        </v-flex>
                        <v-flex>
                          <textarea-form hide-detail :model="form.researchName"
                            @update-data="updateData('researchName', $event)"></textarea-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 4 -->
                      <v-layout>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>วันที่รับรองครั้งสุดท้าย</b>
                        </v-flex>
                        <v-flex xs3 class="text-start">
                          <textfield-form readonly v-if="$route.query.read == 1" hide-detail :model="dateChange1" />
                          <DateInputForm v-else hide-detail :model="dateChange1"
                            @update-data="updateDate('lastDate', $event)" />
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex mx-4 shrink class="d-flex justify-end align-center">
                          <b>วันสิ้นสุดอายุการรับรอง</b>
                        </v-flex>
                        <v-flex xs3>
                          <textfield-form readonly v-if="$route.query.read == 1" hide-detail :model="dateChange2" />
                          <DateInputForm v-else hide-detail :model="dateChange2"
                            @update-data="updateDate('expireDate', $event)" />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Card 2 -->
                <v-card class="mb-12">
                  <v-layout pa-12>
                    <v-flex>
                      <!-- EXPEDITED REVIEW (Check the criteria) -->
                      <v-layout mb-8>
                        <v-flex shrink mr-4 class="text-start d-flex align-center font-weight-bold">
                          <span>วันที่ส่งรายงานความก้าวหน้า</span>
                        </v-flex>
                        <v-flex xs3 class="text-start">
                          <textfield-form readonly v-if="$route.query.read == 1" hide-detail :model="dateChange3" />
                          <DateInputForm v-else hide-detail :model="dateChange3"
                            @update-data="updateDate('sendReportDate', $event)" />
                        </v-flex>
                      </v-layout>

                      <!-- Form Checkbox -->
                      <v-layout style="padding: 1rem 0 0 2rem;">
                        <v-flex class="text-start font-weight-bold">
                          <span>เวลาการส่งรายงาน</span>
                        </v-flex>
                      </v-layout>
                      <v-layout mt-3 style="padding: 0 0 0 10rem;">
                        <v-flex class="text-start">
                          <v-radio-group v-model="form.sendReportTime" :readonly="$route.query.read == 1">
                            <!-- <v-radio class="mb-4" color="#3E7662" style="padding-right: 50px" label="มากกว่า 30 วัน ก่อนหมดอายุการรับรอง" value="1"></v-radio> -->
                            <v-radio class="mb-4" color="#3E7662" style="padding-right: 50px"
                              label="ภายใน 30 วัน ก่อนหมดอายุการรับรอง" value="2"></v-radio>
                            <v-radio color="#3E7662" label="ภายหลังหมดอายุการรับรอง" value="3"></v-radio>
                            <span class="pl-8" style="color: #CC3D45">(วันที่ส่งรายงาน ต้องไม่มากกว่า 60 วัน
                              ก่อนวันหมดอายุการรับรอง)</span>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Card 3 -->
                <v-card class="mb-12">
                  <v-layout py-4 style="background-color: #3E7662;color: white;font-weight: bold">
                    <v-flex>
                      <span>Type of continuing review</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pa-12>
                    <v-flex>
                      <!-- Expedited review -->
                      <v-layout mb-6>
                        <v-flex class="text-start font-weight-bold">
                          <v-checkbox :readonly="$route.query.read == 1" :disabled="form?.fullBoard"
                            v-model="form.expedited" label="Expedited review" color="#3E7662" hide-details></v-checkbox>
                        </v-flex>
                      </v-layout>
                      <!-- Form Text -->
                      <v-layout mt-5 ml-12>
                        <v-flex class="text-start">
                          <div>
                            1. การวิจัยมีความเสี่ยงไม่มากกว่าความเสี่ยงน้อย (minimal
                            risk) และเป็นโครงร่างการวิจัยที่เคยพิจารณาแบบเร็ว
                          </div>
                          <div class="mt-2">
                            2. การวิจัยที่เข้าข่ายการพิจารณาโครงร่างการวิจัยแบบเร็ว
                            (RTA 06_2560)
                          </div>
                          <div class="mt-2">
                            3.
                            การวิจัยที่เคยผ่านการรับรองโครงร่างการวิจัยในที่ประชุมอนุกรรมการฯ
                            (full board) และมีลักษณะต่อไปนี้
                          </div>

                          <div class="mt-12">ก. เมื่อ</div>
                          <div class="mt-2">
                            - ไม่มีการคัดอาสาสมัครใหม่เข้ามาในการวิจัยอีก
                          </div>
                          <div class="mt-2">
                            - อาสาสมัครทุกคนผ่านการทำกิจกรรมหรือหัตถการต่างๆ
                            ของการวิจัยเรียบร้อยแล้ว
                          </div>
                          <div class="mt-2">
                            - การดำเนินการวิจัยที่ยังเหลืออยู่ คือ
                            การติดตามระยะยาวในอาสาสมัคร
                          </div>
                          <div class="mt-2">
                            ข. ยังไม่มีการคัดอาสาสมัครเข้าในการวิจัย
                            และไม่มีข้อมูลความเสี่ยงเพิ่มขึ้น
                          </div>
                          <div class="mt-2">
                            ค. การดำเนินการวิจัยที่ยังเหลืออยู่ คือ
                            การวิเคราะห์ข้อมูล
                          </div>
                        </v-flex>
                      </v-layout>

                      <!-- Full board review -->
                      <v-layout mb-6 style="margin-top: 80px;">
                        <v-flex class="text-start font-weight-bold">
                          <v-checkbox :readonly="$route.query.read == 1" :disabled="form?.expedited"
                            v-model="form.fullBoard" label="Full board review" color="#3E7662"
                            hide-details></v-checkbox>
                        </v-flex>
                      </v-layout>
                      <!-- Form Text -->
                      <v-layout mt-5 ml-12 mb-6>
                        <v-flex class="text-start">
                          <div>
                            รายงานความก้าวหน้าของการวิจัยทุกฉบับ
                            ที่ไม่เข้าข่ายการพิจารณาแบบเร็ว
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Card 4 -->
                <v-card class="mb-12">
                  <!-- Form การทบทวน -->
                  <v-layout pa-12>
                    <v-flex>
                      <!-- Header -->
                      <v-layout py-4 style="background-color: #3E7662;color: white;font-weight: bold;">
                        <v-flex>
                          <span>การทบทวน</span>
                        </v-flex>
                      </v-layout>

                      <!-- Group 1 -->
                      <v-card outlined style="border: solid 1px gray;border-top: none;">
                        <v-layout>
                          <v-flex xs1 style="background-color: #EFEAE7;font-size: 24px;flex: 1">
                            <span class="textAlignVer-ro05">Progression</span>
                          </v-flex>
                          <v-flex style="flex: 1">
                            <!-- row 1 -->
                            <v-layout py-6>
                              <v-flex xs6 px-6 class="text-start d-flex align-center font-weight-bold">
                                <span>1. อัตราการคัดเข้าอาสาสมัคร (recruitment rate)
                                  เหมาะสม</span>
                              </v-flex>
                              <v-flex xs6 class="text-start d-flex align-center">
                                <v-radio-group hide-details v-model="form.isReview1" row
                                  :readonly="$route.query.read == 1">
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ใช่" value="1"></v-radio>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ไม่ใช่"
                                    value="2"></v-radio>
                                  <v-radio color="#3E7662" label="ไม่เกี่ยวข้อง" value="3"></v-radio>
                                </v-radio-group>
                              </v-flex>
                            </v-layout>
                            <!-- row 2 -->
                            <v-layout py-6 style="background-color: #FBF6F3">
                              <v-flex xs6 px-6 class="text-start d-flex align-center font-weight-bold">
                                <span>2. จำนวนและเหตุผลของอาสาสมัครที่ถอนตัว
                                  (withdrawal) เหมาะสม</span>
                              </v-flex>
                              <v-flex xs6 class="text-start d-flex align-center">
                                <v-radio-group hide-details v-model="form.isReview2" row
                                  :readonly="$route.query.read == 1">
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ใช่" value="1"></v-radio>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ไม่ใช่"
                                    value="2"></v-radio>
                                  <v-radio color="#3E7662" label="ไม่เกี่ยวข้อง" value="3"></v-radio>
                                </v-radio-group>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>

                      <!-- Group 2 -->
                      <v-card outlined class="mt-6" style="border: solid 1px gray;">
                        <v-layout>
                          <v-flex xs1 style="background-color: #EFEAE7;font-size: 24px;flex: 1">
                            <span class="textAlignVer-ro05">Protocol</span>
                          </v-flex>
                          <v-flex style="flex: 1">
                            <!-- row 1 -->
                            <v-layout py-6>
                              <v-flex xs6 px-6 class="text-start d-flex align-center font-weight-bold">
                                <span>3.
                                  รายงานส่วนแก้ไขเพิ่มเติมโครงร่างการวิจัยและเอกสารที่เกี่ยวข้อง
                                  ได้รับการรับรองจากคณะอนุกรรมการพิจารณาโครงการวิจัย
                                  พบ. โดยไม่มีปัญหา</span>
                              </v-flex>
                              <v-flex xs6 class="d-flex align-center">
                                <v-radio-group hide-details v-model="form.isReview3" row
                                  :readonly="$route.query.read == 1">
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ใช่" value="1"></v-radio>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ไม่ใช่"
                                    value="2"></v-radio>
                                  <v-radio color="#3E7662" label="ไม่เกี่ยวข้อง" value="3"></v-radio>
                                </v-radio-group>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>

                      <!-- Group 3 -->
                      <v-card class="mt-6" outlined style="border: solid 1px gray;">
                        <v-layout>
                          <v-flex xs1 style="background-color: #EFEAE7;font-size: 24px;flex: 1">
                            <span class="textAlignVer-ro05">Risk</span>
                          </v-flex>
                          <v-flex style="flex: 1">
                            <!-- row 1 -->
                            <v-layout py-6>
                              <v-flex xs6 px-6 class="text-start d-flex align-center font-weight-bold">
                                <span>4. มีการลดความเสี่ยงที่อาจเกิดขึ้นกับอาสาสมัคร
                                  อย่างเหมาะสม</span>
                              </v-flex>
                              <v-flex xs6 class="text-start d-flex align-center">
                                <v-radio-group :readonly="$route.query.read == 1" hide-details v-model="form.isReview4"
                                  row>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ใช่" value="1"></v-radio>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ไม่ใช่"
                                    value="2"></v-radio>
                                  <v-radio color="#3E7662" label="ไม่เกี่ยวข้อง" value="3"></v-radio>
                                </v-radio-group>
                              </v-flex>
                            </v-layout>
                            <!-- row 2 -->
                            <v-layout py-6 style="background-color: #FBF6F3">
                              <v-flex xs6 px-6 class="text-start d-flex align-center font-weight-bold">
                                <span>5. อัตราส่วนความเสี่ยงต่อประโยชน์ของอาสาสมัคร
                                  เหมาะสม</span>
                              </v-flex>
                              <v-flex xs6 class="text-start d-flex align-center">
                                <v-radio-group :readonly="$route.query.read == 1" hide-details v-model="form.isReview5"
                                  row>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ใช่" value="1"></v-radio>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ไม่ใช่"
                                    value="2"></v-radio>
                                  <v-radio color="#3E7662" label="ไม่เกี่ยวข้อง" value="3"></v-radio>
                                </v-radio-group>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>

                      <!-- Group 4 -->
                      <v-card outlined class="mt-6" style="border: solid 1px gray;">
                        <v-layout>
                          <v-flex xs1 style="background-color: #EFEAE7;font-size: 24px;flex: 1">
                            <span class="textAlignVer-ro05">Equity</span>
                          </v-flex>
                          <v-flex style="flex: 1">
                            <!-- row 1 -->
                            <v-layout my-4 py-6>
                              <v-flex xs6 px-6 class="text-start d-flex align-center font-weight-bold">
                                <span>6. การคัดเลือกอาสาสมัคร ยุติธรรม เหมาะสม</span>
                              </v-flex>
                              <v-flex xs6 class="d-flex align-center">
                                <v-radio-group :readonly="$route.query.read == 1" hide-details v-model="form.isReview6"
                                  row>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ใช่" value="1"></v-radio>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ไม่ใช่"
                                    value="2"></v-radio>
                                  <v-radio color="#3E7662" label="ไม่เกี่ยวข้อง" value="3"></v-radio>
                                </v-radio-group>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>

                      <!-- Group 5 -->
                      <v-card class="mt-6" outlined style="border: solid 1px gray;">
                        <v-layout>
                          <v-flex xs1 style="background-color: #EFEAE7;font-size: 24px;flex: 1">
                            <span class="textAlignVer-ro05">Informed consent</span>
                          </v-flex>
                          <v-flex style="flex: 1">
                            <!-- row 1 -->
                            <v-layout py-6>
                              <v-flex xs6 px-6 class="text-start d-flex align-center font-weight-bold">
                                <span>7.
                                  เอกสารชี้แจงข้อมูลแก่อาสาสมัครและเอกสารแสดงเจตนายินยอม
                                  เป็นฉบับที่รับรองล่าสุดจากคณะอนุกรรมการพิจารณาโครงการวิจัย
                                  พบ.</span>
                              </v-flex>
                              <v-flex xs6 class="text-start d-flex align-center">
                                <v-radio-group :readonly="$route.query.read == 1" hide-details v-model="form.isReview7"
                                  row>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ใช่" value="1"></v-radio>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ไม่ใช่"
                                    value="2"></v-radio>
                                  <v-radio color="#3E7662" label="ไม่เกี่ยวข้อง" value="3"></v-radio>
                                </v-radio-group>
                              </v-flex>
                            </v-layout>
                            <!-- row 2 -->
                            <v-layout py-6 style="background-color: #FBF6F3">
                              <v-flex xs6 px-6 class="text-start d-flex align-center font-weight-bold">
                                <span>8.
                                  เอกสารชี้แจงข้อมูลแก่อาสาสมัครมีข้อมูลใหม่ที่เกี่ยวข้องกับ
                                  โครงการวิจัย</span>
                              </v-flex>
                              <v-flex xs6 class="text-start d-flex align-center">
                                <v-radio-group :readonly="$route.query.read == 1" hide-details v-model="form.isReview8"
                                  row>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ใช่" value="1"></v-radio>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ไม่ใช่"
                                    value="2"></v-radio>
                                  <v-radio color="#3E7662" label="ไม่เกี่ยวข้อง" value="3"></v-radio>
                                </v-radio-group>
                              </v-flex>
                            </v-layout>
                            <!-- row 3 -->
                            <v-layout py-6>
                              <v-flex xs6 px-6 class="text-start d-flex align-center font-weight-bold">
                                <span>9. กระบวนการขอความยินยอมจากอาสาสมัคร
                                  หรือจากผู้แทนโดย ชอบธรรม เหมาะสม</span>
                              </v-flex>
                              <v-flex xs6 class="text-start d-flex align-center">
                                <v-radio-group :readonly="$route.query.read == 1" hide-details v-model="form.isReview9"
                                  row>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ใช่" value="1"></v-radio>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ไม่ใช่"
                                    value="2"></v-radio>
                                  <v-radio color="#3E7662" label="ไม่เกี่ยวข้อง" value="3"></v-radio>
                                </v-radio-group>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>

                      <!-- Group 5 -->
                      <v-card class="mt-6" outlined style="border: solid 1px gray;">
                        <v-layout>
                          <v-flex xs1 style="background-color: #EFEAE7;font-size: 24px;flex: 1">
                            <span class="textAlignVer-ro05">Others</span>
                          </v-flex>
                          <v-flex style="flex: 1">
                            <!-- row 1 -->
                            <v-layout py-6>
                              <v-flex xs6 px-6 class="text-start d-flex align-center font-weight-bold">
                                <span>10. มีการเก็บข้อมูลอย่างเหมาะสม</span>
                              </v-flex>
                              <v-flex xs6 class="text-start d-flex align-center">
                                <v-radio-group :readonly="$route.query.read == 1" hide-details v-model="form.isReview10"
                                  row>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ใช่" value="1"></v-radio>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ไม่ใช่"
                                    value="2"></v-radio>
                                  <v-radio color="#3E7662" label="ไม่เกี่ยวข้อง" value="3"></v-radio>
                                </v-radio-group>
                              </v-flex>
                            </v-layout>
                            <!-- row 2 -->
                            <v-layout py-6 style="background-color: #FBF6F3">
                              <v-flex xs6 px-6 class="text-start d-flex align-center font-weight-bold">
                                <span>11. มีการรักษาความลับของข้อมูลและ
                                  การระมัดระวังเรื่องความเป็น
                                  ส่วนตัวของอาสาสมัครอย่างเหมาะสม</span>
                              </v-flex>
                              <v-flex xs6 class="text-start d-flex align-center">
                                <v-radio-group :readonly="$route.query.read == 1" hide-details v-model="form.isReview11"
                                  row>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ใช่" value="1"></v-radio>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ไม่ใช่"
                                    value="2"></v-radio>
                                  <v-radio color="#3E7662" label="ไม่เกี่ยวข้อง" value="3"></v-radio>
                                </v-radio-group>
                              </v-flex>
                            </v-layout>
                            <!-- row 3 -->
                            <v-layout py-6>
                              <v-flex xs6 px-6 class="text-start d-flex align-center font-weight-bold">
                                <span>12.
                                  มีการปกป้องคุ้มครองอาสาสมัครกลุ่มอ่อนแอและเปราะบาง
                                  อย่างเหมาะสม</span>
                              </v-flex>
                              <v-flex xs6 class="text-start d-flex align-center">
                                <v-radio-group :readonly="$route.query.read == 1" hide-details v-model="form.isReview12"
                                  row>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ใช่" value="1"></v-radio>
                                  <v-radio style="margin-right: 5rem" color="#3E7662" label="ไม่ใช่"
                                    value="2"></v-radio>
                                  <v-radio color="#3E7662" label="ไม่เกี่ยวข้อง" value="3"></v-radio>
                                </v-radio-group>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>

                      <!-- ความเห็นและข้อเสนอแนะ -->
                      <v-layout class="mb-4" style="margin-top: 100px">
                        <v-flex class="text-start font-weight-bold">
                          <span>ความเห็นและข้อเสนอแนะ</span>
                        </v-flex>
                      </v-layout>
                      <v-layout style="margin-bottom: 50px;">
                        <v-flex>
                          <textarea-form :readonly="$route.query.read == 1" :model="form.adviceTextBox" hide-detail
                            @update-data="updateData('adviceTextBox', $event)" />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <!-- Form ผลการพิจารณารายงานความก้าวหน้าของการวิจัย -->
                  <v-layout py-4 style="background-color: #3E7662;color: white;font-weight: bold">
                    <v-flex>
                      <span>ผลการพิจารณารายงานความก้าวหน้าของการวิจัย</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pa-12>
                    <v-flex>
                      <v-layout mb-6>
                        <v-flex class="text-start">
                          <span class="font-weight-bold">ผลการพิจารณา</span>
                        </v-flex>
                      </v-layout>
                      <v-layout mt-5 ml-6>
                        <v-flex class="text-start">
                          <v-radio-group :readonly="$route.query.read == 1" v-model="form.summary">
                            <v-radio class="mb-4" color="#3E7662" label="รับรอง" value="1"></v-radio>
                            <v-radio class="mb-4" color="#3E7662" label="รับรอง ภายหลังได้รับข้อมูลเพิ่มเติม"
                              value="2"></v-radio>
                            <v-radio class="mb-4" color="#3E7662" label="นำเข้าพิจารณาในที่ประชุมคณะอนุกรรมการฯ"
                              value="3"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <!-- Form ความถี่ของการส่งรายงานความก้าวหน้า -->
                  <v-layout py-4 style="background-color: #3E7662;color: white;font-weight: bold">
                    <v-flex>
                      <span>ความถี่ของการส่งรายงานความก้าวหน้า</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pa-12>
                    <v-flex>
                      <v-layout mb-6>
                        <v-flex class="text-start">
                          <span class="font-weight-bold">ผลการพิจารณา</span>
                        </v-flex>
                      </v-layout>
                      <v-layout mt-5 ml-6>
                        <v-flex class="text-start">
                          <v-radio-group :readonly="$route.query.read == 1" v-model="form.frequency">
                            <v-radio class="mb-4" color="#3E7662" label="6 เดือน" value="1"></v-radio>
                            <v-radio class="mb-4" color="#3E7662" label="1 ปี" value="2"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <!-- ผู้ประเมิน -->
                  <v-layout px-12 style="margin-top: 100px;">
                    <v-flex xs6 class="text-start">
                      <v-layout>
                        <v-flex xs3 mt-4 class="justify-end font-weight-bold d-flex align-center">
                          <span>ผู้ประเมิน ทบทวน</span>
                        </v-flex>
                        <v-flex xs6 class="text-start text-field-center">
                          <v-text-field :readonly="$route.query.read == 1" hide-details v-model="form.signature"
                            color="#3E7662" append-icon="edit" />
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex xs3></v-flex>
                        <v-flex xs6 class=" text-field-center">
                          <v-layout>
                            <v-flex mr-2 mt-5 shrink class="d-flex align-center">
                              <span>(</span>
                            </v-flex>
                            <v-flex>
                              <v-text-field :readonly="$route.query.read == 1" hide-details v-model="form.signature"
                                color="#3E7662" />
                            </v-flex>
                            <v-flex ml-2 mt-5 shrink class="d-flex align-center">
                              <span>)</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-spacer></v-spacer>
                      </v-layout>
                    </v-flex>
                    <v-flex xs6>
                      <v-layout>
                        <v-spacer></v-spacer>
                        <v-flex shrink mr-4 class="text-end font-weight-bold d-flex align-center">
                          <span>วันที่ทบทวน</span>
                        </v-flex>
                        <v-flex xs5 class="text-end">
                          <DateInputForm hide-detail :model="dateChange4"
                            @update-data="updateDate('reviewDate', $event)" />
                        </v-flex>
                        <v-spacer></v-spacer>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <!-- Date -->
                  <v-layout mt-8 style="margin-bottom: 100px;">
                    <v-flex xs3> </v-flex>
                  </v-layout>

                  <v-layout class="pl-12 pb-12">
                    <v-flex class="text-start font-weight-bold">
                      <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Button Save -->
                <v-layout mt-8>
                  <v-flex mb-12 style="text-align: right;">
                    <v-layout>
                      <v-flex>
                        <v-btn style="color: #3E7662" class="mx-4" depressed color="#ffffff"
                          @click="$route.go(-1)">ย้อนกลับ</v-btn>
                        <v-btn depressed dark class="mx-4" color="#3E7662" @click="saveDraft">
                          <span>บันทึกข้อมูล</span>
                        </v-btn>
                        <v-btn v-if="$route.query.read == 0" depressed dark color="#3E7662" @click="save">
                          <span>บันทึกข้อมูลและส่งการประเมิน</span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-pageAndLine="fullpageAndLine">
        </loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../components/input/TextfieldForm";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
import { mapState } from "vuex";
import domtoimage from "dom-to-image";

export default {
  name: "FormRO06",
  components: {
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
  },
  data: () => ({
    isLoading: false,
    fullpageAndLine: true,
    form: {
      researchID: "",
      researchCode: "",
      firstName: "",
      lastName: "",
      researchName: "",
      expireDate: "",
      lastDate: "",
      sendReportDate: "",
      sendReportTime: "",
      expedited: false,
      fullBoard: false,
      isReview1: "",
      isReview2: "",
      isReview3: "",
      isReview4: "",
      isReview5: "",
      isReview6: "",
      isReview7: "",
      isReview8: "",
      isReview9: "",
      isReview10: "",
      isReview11: "",
      isReview12: "",
      adviceTextBox: "",
      summary: "",
      frequency: "",
      signature: "",
      reviewDate: "",
    },
    dateChange1: "",
    dateChange2: "",
    dateChange3: "",
    dateChange4: "",
  }),
  created() {
    if (this.$route.query.read == 1) {
      this.getRO06_1();
    } else {
      this.form.researchCode = this.$route.query.researchCode;
      this.form.researchName = this.$route.query.researchName;
      this.form.firstName = this.$route.query.firstName;
      this.form.lastName = this.$route.query.lastName;
      // this.form.signature = this.user.thName;
      this.dateChange1 = this.$route.query.sendReportDate;
      this.dateChange2 = this.$route.query.approvalExpireDate;
      this.form.lastDate = this.$route.query.approvalDate;
      this.form.expireDate = this.$route.query.approvalExpireDate;
      this.form.sendReportDate = this.$route.query.sendReportDate;
      this.form.sendReportTime = this.$route.query.sendReportTime;
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  methods: {
    async printPage() {
      this.printMode = true
      document.getElementsByClassName("print-form")[0].style.backgroundColor =
        "#fff";
      await document.querySelectorAll("button").forEach(function (element) {
        element.style.display = 'none'
      });
      await document.querySelectorAll(".v-icon").forEach(function (element) {
        element.style.display = 'none'
      });
      await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element) {
        element.innerHTML = '✓' + element.innerHTML
      })
      await document.getElementsByClassName("v-radio v-item--active").forEach(function (element) {
        element.innerHTML = '✓ ' + element.innerHTML
      })
      var node = document.getElementById("print");
      var self = this;
      domtoimage
        .toPng(node)
        .then(async function (dataUrl) {
          var img = new Image();
          img.src = dataUrl;
          var page = self.imageToPrint(img);

          var pageLink = "about:blank";
          var pwa = window.open(pageLink, "_new");
          pwa.document.open();
          pwa.document.write(page);
          pwa.document.close();
          self.printMode = false
          await document.querySelectorAll("button").forEach(function (element) {
            element.style.display = 'unset'
          });
          await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element) {
            element.innerHTML = element.innerHTML.replace('✓', '')
          })
          await document.getElementsByClassName("v-radio v-item--active").forEach(function (element) {
            element.innerHTML = element.innerHTML.replace('✓ ', '')
          })
          await document.querySelectorAll(".v-icon").forEach(function (element) {
            element.style.display = 'unset'
          });
          document
            .getElementsByClassName("print-form")[0]
            .removeAttribute("style");
        })
        .catch(function (error) {
          Swal.fire({
            title: "กรุณาเปิดการอนุญาต Pop Up!",
            description: "",
            icon: "error",
            confirmButtonColor: "#3E7662",
            cancelButtonColor: "rgb(189, 189, 189)",
            confirmButtonText: "ตกลง",
          }).then(async function () {

            await document.querySelectorAll("button").forEach(function (element) {
              element.style.display = 'unset'
            });
            await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element) {
              element.innerHTML = element.innerHTML.replace('✓', '')
            })
            await document.getElementsByClassName("v-radio v-item--active").forEach(function (element) {
              element.innerHTML = element.innerHTML.replace('✓ ', '')
            })
            await document.querySelectorAll(".v-icon").forEach(function (element) {
              element.style.display = 'unset'
            });
            document
              .getElementsByClassName("print-form")[0]
              .removeAttribute("style");
          })
        });
    },
    imageToPrint(source) {
      return (
        "<html><body onload='window.print()'><style>@media print {\n" +
        "  @page { margin: 0; }\n" +
        "  html, body {\n" +
        "    margin: 0;\n" +
        "    width: 210mm;\n" +
        "    height: 297mm;\n" +
        "  }\n" +
        "  img {\n" +
        "    margin-top: 10mm;\n" +
        "    margin-left: 20mm;\n" +
        "    width: 170mm;\n" +
        // "    height: 297mm;\n" +
        "  }\n" +
        "}</style>" +
        source.outerHTML +
        "</body></html>"
      );
    },
    updateData(name, val) {
      this.form[name] = val;
    },
    updateDate(name, val) {
      const value = val.date ? val.date : val;
      if (name === "lastDate") {
        this.form.lastDate = value;
        this.dateChange1 = this.changeDate(value);
      }
      if (name === "expireDate") {
        this.form.expireDate = value;
        this.dateChange2 = this.changeDate(value);
      }
      if (name === "sendReportDate") {
        this.form.sendReportDate = value;
        this.dateChange3 = this.changeDate(value);
      }
      if (name === "reviewDate") {
        this.form.reviewDate = value;
        this.dateChange4 = this.changeDate(value);
      }
      if (name === "lastDateGet") {
        this.form.lastDate = value;
        this.dateChange1 = this.changeDate(value);
      }
      if (name === "expireDateGet") {
        this.form.expireDate = value;
        this.dateChange2 = this.changeDate(value);
      }
      if (name === "sendReportDateGet") {
        this.form.sendReportDate = value;
        this.dateChange3 = this.changeDate(value);
      }
      if (name === "reviewDateGet") {
        this.form.reviewDate = value;
        this.dateChange4 = this.changeDate(value);
      }
    },
    changeDate(val) {
      let sub_year = val?.substring(0, 4);
      let sub_month = val?.substring(5, 7);
      let sub_day = val?.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    checkbox(name) {
      if (name === "checkTheCriteria11") {
        if (!this.form.checkTheCriteria11) {
          this.form.criteria11 = "";
        }
      }
      if (name === "hasFullBoardReview") {
        if (!this.form.hasFullBoardReview) {
          this.form.fullBoardReview = "";
        }
      }
    },
    save() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;
          this.$store
            .dispatch("FormRO/saveRO06_1", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.go(-1);
              });
              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
              // Swal.fire({
              //     title: 'Save failed!',
              //     text: 'บันทึกไม่สำเร็จ',
              //     icon: 'warning',
              // })
              // this.isLoading = false;
            });
        }
      });
    },
    saveDraft() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;
          this.$store
            .dispatch("FormRO/saveDraftRO06_1", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.go(-1);
              });
              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
              // Swal.fire({
              //     title: 'Save failed!',
              //     text: 'บันทึกไม่สำเร็จ',
              //     icon: 'warning',
              // })
              // this.isLoading = false;
            });
        }
      });
    },
    async getCreateRO06_1Data() {
      this.isLoading = true;
      await this.$store
        .dispatch("FormRO/getCreateRO06_1", {
          researchID: this.$route.query.id,
          rfID: this.$route.query.rfID,
        })
        .then((res) => {
          this.updateDate("reviewDate", {
            date: new Date().toISOString().substr(0, 10),
          });
          this.form.researchID = res.researchID;
          this.form.researchCode = res.researchCode;
          this.form.firstName = res.firstName;
          this.form.lastName = res.lastName;
          this.form.researchName = res.researchName;
          this.form.signature = res.reviewer.thName;
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });

    },
    getRO06_1() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRO/getRO06_1", this.$route.query.rfID)
        .then((res) => {
          if (res !== "don't have ro06_1 yet") {
            console.log(res);
            this.form.researchID = res.researchID;
            this.form.researchCode = res.researchCode;
            this.form.firstName = res.firstName;
            this.form.lastName = res.lastName;
            this.form.researchName = res.researchName;
            this.form.sendReportTime = res.sendReportTime.toString();
            this.form.expedited = res.expedited;
            this.form.fullBoard = res.fullBoard;
            this.form.isReview1 = res.isReview1.toString();
            this.form.isReview2 = res.isReview2.toString();
            this.form.isReview3 = res.isReview3.toString();
            this.form.isReview4 = res.isReview4.toString();
            this.form.isReview5 = res.isReview5.toString();
            this.form.isReview6 = res.isReview6.toString();
            this.form.isReview7 = res.isReview7.toString();
            this.form.isReview8 = res.isReview8.toString();
            this.form.isReview9 = res.isReview9.toString();
            this.form.isReview10 = res.isReview10.toString();
            this.form.isReview11 = res.isReview11.toString();
            this.form.isReview12 = res.isReview12.toString();
            this.form.adviceTextBox = res.adviceTextBox;
            this.form.summary = res.summary.toString();
            this.form.frequency = res.frequency.toString();
            this.form.signature = res.signature;
            this.dateChange1 = res.sendReportDate;
            this.dateChange2 = res.expireDate;
            this.reviewDate = res.reviewDate;
            this.updateDate("reviewDate", res.reviewDate);
            this.updateDate("lastDate", res.lastDate);
            this.updateDate("expireDate", res.expireDate);
            this.updateDate("sendReportDate", res.sendReportDate);
          }

          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
          this.getCreateRO06_1Data()
        });
    },
  },
};
</script>

<style lang="scss">
.table-ro4-1 {

  /*** Table Styles **/
  .table-style-ro04-1 {
    .v-input__slot {
      align-items: center;
      justify-content: center;
    }

    .table-fill-ro04-1 {
      background: white;
      border-radius: 3px;
      border-collapse: collapse;
      margin: auto;
      padding: 5px;
      width: 100%;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
      animation: float 5s infinite;
      /*border-bottom: 5px solid #544A44;*/
    }

    th {
      color: #ffffff;
      background: #3e7662;
      /*border-top:5px solid #544A44;*/
      border-right: 0.75px solid gray;
      font-weight: 700;
      padding: 15px;
      vertical-align: middle;
    }

    tr {
      border-top: 1px solid #544a44;
      border-bottom-: 1px solid #544a44;
    }

    th:first-child {
      border-top-left-radius: 3px;
    }

    th:last-child {
      border-top-right-radius: 3px;
      border-right: none;
    }

    tr:first-child {
      /*border-top: none;*/
    }

    tr:last-child {
      /*border-bottom:5px solid #544A44;*/
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 3px;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 3px;
    }

    td {
      background: #ffffff;
      padding: 10px 30px 10px 30px;
      text-align: left;
      vertical-align: middle;
      font-weight: 700;
      color: black;
      border-right: 0.5px solid gray;
      border-top: 0.5px solid gray;
    }

    td:last-child {
      border-right: 0px;
    }

    th.text-left {
      text-align: left;
    }

    th.text-center {
      text-align: center;
    }

    th.text-right {
      text-align: right;
    }

    td.text-left {
      text-align: left;
    }

    td.text-center {
      text-align: center;
    }

    td.text-right {
      text-align: right;
    }
  }
}

.text-field-color {

  .theme--light.v-input,
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    color: #cc3d45;
  }
}

.text-field-margin {
  .v-text-field {
    padding: 0;
    margin: 0;
  }
}

.textAlignVer-ro05 {
  color: #544a44;
  transform-origin: 0 50%;
  transform: rotate(-90deg) translate(-50%, 50%);
  position: absolute;
  top: 0;
  bottom: 0;
  height: 2em;
  /* line-height of .wrapper div:first-child span */
  margin: auto;
  font-weight: bold;
  font-size: 1em;
  line-height: 2em;
  /* Copy to other locations */
  left: 15px;
}
</style>
